import { PRODUCT_REQUEST_MESSAGES, ProductRequestMessages } from "./product.request.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ProductTableMessages = ProductRequestMessages &
  TableColumnsMessages & {
    // COLUMNS MESSAGES
    codeColumn: string;
    externalCodeColumn: string;
    titleColumn: string;
    shortDescriptionColumn: string;
    complementaryDescriptionColumn: string;
    brandColumn: string;
    typeColumn: string;
    ncmColumn: string;
    categoryColumn: string;
    warrantyColumn: string;
    pickUpInStoreColumn: string;
    expandColumn: string;
    statusColumn: string;
    optionsColumn: string;
    stockColumn: string;

    // Sort
    sortByLabel: string;
    sortDirectionLabel: string;
    sortDirectionAsc: string;
    sortDirectionDesc: string;

    //Options messages
    kitOption: string;
    simpleProductOption: string;
    variationProductOption: string;
    skuInactiveLabel: string;
  };

export const PRODUCT_TABLE_MESSAGES: ProductTableMessages = {
  // COLUMNS MESSAGES
  codeColumn: "Código",
  externalCodeColumn: "Código Externo",
  titleColumn: "Nome do produto",
  shortDescriptionColumn: "Descrição curta",
  complementaryDescriptionColumn: "Descrição complementar",
  brandColumn: "Marca",
  typeColumn: "Variação",
  ncmColumn: "NCM",
  categoryColumn: "Categoria",
  warrantyColumn: "Garantia",
  pickUpInStoreColumn: "Retire na loja",
  expandColumn: "",
  statusColumn: "Ativo",
  stockColumn: "Estoque",
  sortByLabel: "Ordenar por",
  sortDirectionLabel: "Direção",
  sortDirectionAsc: "Ascendente",
  sortDirectionDesc: "Descendente",

  //Options messages
  kitOption: "KIT",
  simpleProductOption: "Simples",
  variationProductOption: "Variação",
  skuInactiveLabel: "Inativo",

  ...TABLE_COLUMNS_MESSAGES,
  ...PRODUCT_REQUEST_MESSAGES,
};
